export default "__VITE_ASSET__CQHjq8QK__"